



























































































































import Vue from "vue";
import { Component, Ref } from "vue-property-decorator";
import { mapGetters, mapState } from "vuex";
import AppSettings from "@/appsettings";
import ImportService from "@/services/importService";
import RequestService from "@/services/requestService";
// @ts-ignore
import { UploadCloudIcon } from "vue-feather-icons";
import ISetting from "@/interfaces/setting";

@Component({
  components: {
    UploadCloudIcon,
  },
  computed: {
    ...mapGetters("subscriptions", ["hasActiveSubscription"]),
    ...mapGetters("settings", ["selectedHttpMethod", "selectedScheme"]),
    ...mapState("settings", ["availableSchemes"]),
  },
})
export default class AddImport extends Vue {
  // computed
  hasActiveSubscription!: boolean;
  selectedHttpMethod!: string;
  selectedScheme!: string;
  availableSchemes!: Array<string>;
  loading = false;

  importService: ImportService = new ImportService();

  @Ref("fileInput")
  fileInput!: HTMLInputElement;

  get localAddScheme() {
    return this.selectedScheme;
  }

  set localAddScheme(newValue: string) {
    let payload = {
      key: "AddScheme",
      value: newValue,
    };

    this.updateSetting(payload).then(
      () => {
        // nothing
      },
      () => {
        this.$message({
          message: "Something went wrong while updating the scheme setting",
          type: "error",
        });
      }
    );
  }

  updateSetting(payload: ISetting) {
    return new Promise((resolve, reject) => {
      this.$store.dispatch("settings/update", payload).then(
        () => {
          resolve();
        },
        () => {
          reject();
        }
      );
    });
  }

  get maximumUrlsPerBatch(): number {
    return AppSettings.MaximumRequestsPerBatch.Free;
  }

  get previewLengthFree(): number {
    return this.importService.previewLength - 4 >
      AppSettings.MaximumRequestsPerBatch.Free
      ? 250 - 4
      : this.importService.previewLength - 4;
  }

  loadTextFromFile(ev: Event) {
    // @ts-ignore
    if (!ev.target.files) return;
    // @ts-ignore
    const file = ev.target.files[0];
    //
    // Check if the mimetype is in our accepted mimetypes
    // If the mimetype is empty, accept it (Windows) doesn't always
    // set a mimetype for CSV files.
    if (
      !AppSettings.uploadAcceptedMimeTypes.includes(file.type) &&
      file.type !== ""
    ) {
      this.$message({
        message: "This file is not supported. Please upload a valid CSV file.",
        type: "error",
      });
      return;
    }
    //
    // Check if the file isn't larger than
    // the maximum allowed size
    if (file.size > AppSettings.uploadMaximumFileSize) {
      this.$message({
        message:
          "The uploaded file is too big. Please try again with a smaller file.",
        type: "error",
      });
      return;
    }

    this.importService.ReadFromFile(file);
  }

  process() {
    this.loading = true;

    RequestService.AddRequestsFromCsv(
      this.importService.dataToImport,
      this.importService.selectedColumn,
      this.selectedHttpMethod,
      this.selectedScheme,
      this.hasActiveSubscription
    );
    //
    // Add the urls
    const requests = RequestService.GetAndEmptyRequests();
    //
    // Using setTimeout for UX purposes
    setTimeout(() => {
      // clear the input field and emit 'ready' event
      this.$emit("ready", requests);
      //
      // Dispose and close
      this.loading = false;
      this.close();
    }, 950);
  }

  close() {
    this.fileInput.value = "";
    this.importService.Dispose();
  }
}
